<template>
    <div>
        <b-modal
            id="addRelationModal"
            :hideFooter="true"
            :title="title"
            ref="relationModal"
            size="lg"
        >
            <form-relation
                ref="relationForm"
                @relationStored="addRelation"
                :openInModal="false"
                :showOrganisation="false"
            />
        </b-modal>
        <div class="col-12 list-holder mb-3">
            <a href="#"
                class="btn btn-brand"
                @click.prevent="createRelation"
            >{{ uLang('app.add_type', { type: this.uLang('app.relation') }) }}</a>

            <div class="row mt-3" v-if="relations.length > 0">
                <div class="col-xl-4 col-lg-6 col-md-12 mb-3" v-for="relation in relations">
                    <relation-card
                        :relation="relation"
                        :deleteRelation="removeRelation"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import FormRelation from '~/components/forms/admin/relation/form'
    import RelationCard from '~/components/cards/relation-card'

    export default {
        name: "RelationModule",

        components: {
            FormRelation,
            RelationCard,
        },

        props: {
            title: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                relations: [],
            };
        },

        methods: {
            clear() {
                this.relations = [];
            },

            createRelation() {
                this.$refs.relationForm.form.reset()
                this.$refs.relationModal.show();
            },

            addRelation(relation) {
                this.$refs.relationModal.hide();
                this.relations.push(relation);
                this.$emit('relationsUpdated', this.relations)
            },

            removeRelation(relation){
                this.relations = this.relations.filter(function (current_relation) {
                    return relation.id != current_relation.id;
                });
            },
        }
    }
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
    .remove-relation {
        margin-right: 20px;
    }
</style>
